import App from "./App";
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import rootReducer from "./redux/reducers";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./style.css";

const store = configureStore({
  reducer: rootReducer,
  // Datasets pueden tener 100k+ features (rangos multi-día). Los checks
  // de serializable/immutable que corren en dev recorren el state entero
  // en cada dispatch y agregan +1s por acción. En prod no se ejecutan,
  // así que apagarlos sólo afecta DX local.
  middleware: (getDefault) => getDefault({
    serializableCheck: false,
    immutableCheck: false,
  }),
});

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>
);
